<div id="generate-images" class="m-3">
    <h1>Generar imágenes</h1>

    <div id="ai-options">
        <div id="ai-options-model" class="mb-4">
            <p class="fw-bold">Modelo:</p>
            <label class="d-block">
                <input type="radio" name="model" [(ngModel)]="model" value="dall-e-3">
                <span class="ms-1">DALL-E 3</span>
            </label>
            <label class="d-block">
                <input type="radio" name="model" [(ngModel)]="model" value="dall-e-2">
                <span class="ms-1">DALL-E 2</span>
            </label>
            <label class="d-block">
                <input type="radio" name="model" [(ngModel)]="model" value="stable-diffusion">
                <span class="ms-1">Stable Diffusion (v2.1)</span>
            </label>
            <!--
            <label class="d-block">
                <input type="radio" name="model" [(ngModel)]="model" value="openjourney">
                <span class="ms-1">OpenJourney</span>
            </label>
            -->
            <!--
            <label class="d-block">
                <input type="radio" name="model" [(ngModel)]="model" value="openjourney-v4">
                <span class="ms-1">OpenJourney (v4)</span>
            </label>
            -->
        </div>
        <div id="ai-options-prompt" class="mb-4" *ngIf="model != ''">
            <p class="fw-bold">Descripción de la imagen:</p>
            <p class="fw-bold">(Nota: Si las imágenes generadas no coinciden con la descripción, intente escribir la descripción en inglés.)</p>
            <label class="d-block">
                <input type="text" [(ngModel)]="prompt" size="150">
            </label>
        </div>
        <div id="ai-options-number" class="mb-4" *ngIf="model != '' && model != 'dall-e-3'">
            <p class="fw-bold">Número de imágenes a generar:</p>
            <p class="fw-bold">(OJO: Entre más imágenes se generen, más tardará el proceso)</p>
            <label class="d-block">
                <input type="number" [(ngModel)]="number" min="1" max="10">
            </label>
        </div>
        <div id="ai-options-size" class="mb-4" *ngIf="model == 'dall-e-3' || model == 'dall-e-2'">
            <p class="fw-bold">Tamaño de las imágenes a generar:</p>
            <label class="d-block" *ngIf="model == 'dall-e-2'">
                <input type="radio" name="size" [(ngModel)]="size" value="256x256">
                <span class="ms-1">256x256</span>
            </label>
            <label class="d-block" *ngIf="model == 'dall-e-2'">
                <input type="radio" name="size" [(ngModel)]="size" value="512x512">
                <span class="ms-1">512x512</span>
            </label>
            <label class="d-block">
                <input type="radio" name="size" [(ngModel)]="size" value="1024x1024">
                <span class="ms-1">1024x1024</span>
            </label>
            <label class="d-block" *ngIf="model == 'dall-e-3'">
                <input type="radio" name="size" [(ngModel)]="size" value="1024x1792">
                <span class="ms-1">1024x1792</span>
            </label>
            <label class="d-block" *ngIf="model == 'dall-e-3'">
                <input type="radio" name="size" [(ngModel)]="size" value="1792x1024">
                <span class="ms-1">1792x1024</span>
            </label>
        </div>
    </div>

    <div id="generate-images-status" class="mt-3">
        <div id="generate-images-loading" *ngIf="imageGenerating">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Generando imágenes, espere por favor...</span>
        </div>
        <div id="generate-images-success" class="text-success" *ngIf="imageGenerateSuccess">
            <i class="fa fa-check"></i>
            <span>¡Imágenes generadas exitosamente!</span>
        </div>
        <div id="generate-images-error" class="text-danger" *ngIf="imageGenerateError">
            <i class="fa fa-times"></i>
            <span>Las imágenes no se pudieron generar correctamente.</span>
            <p>Mensaje del servidor: {{ imageGenerateErrorMessage }}</p>
            <!--
            <p>Posibles razones:</p>
            <ul>
                <li>Ha tratado de generar demasiadas imágenes. Por favor, use un número menor.</li>
                <li>El servidor está sobrecargado. Espere unos minutos.</li>
            </ul>
            <p>Por favor, inténtelo de nuevo.</p>
            -->
        </div>
    </div>

    <div id="generate-images-buttons" class="mt-3">
        <button class="btn btn-primary me-3" routerLink="/course/{{ courseID }}" routerLinkActive="active">
            <i class="fa fa-arrow-left"></i>
            <span>Volver</span>
        </button>

        <button class="btn btn-success me-3" (click)="generateImages()" [attr.disabled]="imageGenerating ? 'disabled' : null">
            <i class="fa fa-brain"></i>
            <i class="fa fa-images"></i>
            <span>Generar imágenes</span>
        </button>
    </div>

    <div id="generate-images-result" *ngIf="imageGenerateSuccess" class="mt-4">
        <p class="fw-bold">Resultado:</p>
        <ul id="generated-images" *ngIf="images.length > 0">
            <li *ngFor="let image of images; let i = index;" [ngClass]="{'selected' : imageIsSelected(image) > -1}">
                <label class="d-block">
                    <img width="200" height="200" [src]="image.link" [alt]="prompt" [title]="prompt">
                    <div class="mb-3">
                        <p class="fw-bold">Tamaño: {{ image.size }} KB</p>
                        <p class="fw-bold">Dimensiones: {{ image.width }} x {{ image.height }}</p>
                    </div>
                    <div class="mb-3">
                        <a class="btn btn-primary" title="Ver (Para descargar, haz clic derecho y selecciona 'Guardar enlace como...')" [href]="image.link" target="_blank">
                            <i class="fa fa-eye"></i>
                        </a>
                    </div>
                    <div class="mb-3">
                        <input type="checkbox" [attr.checked]="imageIsSelected(image) > -1 ? 'checked' : null" (change)="selectImage(image)">
                        <span class="fw-bold ms-3">Seleccionar para añadir</span>
                    </div>
                </label>
            </li>
        </ul>
    </div>

    <div id="generate-images-destination" *ngIf="selectedImages.length > 0" class="mt-4">
        <p class="fw-bold">Destino de la imagen:</p>
        <label class="d-block">
            <input type="radio" name="image-destination" value="lesson" (click)="destination = 'lesson'">
            <span class="ms-1">Asociar a lección</span>
        </label>
        <label class="d-block">
            <input type="radio" name="image-destination" value="heading" (click)="destination = 'heading'">
            <span class="ms-1">Insertar en enunciado</span>
        </label>
    </div>

    <div id="generate-images-destination-course" *ngIf="destination != ''" class="mt-4">
        <label for="course-units" class="d-block" *ngIf="courseUnits">
            <p class="fw-bold">Unidad:</p>
            <select name="course-units" id="course-units" [(ngModel)]="selectedUnit" (ngModelChange)="selectUnit($event)">
                <option disabled selected value="-1">Seleccione una unidad...</option>
                <option *ngFor="let unit of courseUnits" value="{{ unit.id }}">
                    {{ unit.name }}
                </option>
            </select>
        </label>
        
        <label for="units-lessons" class="d-block" *ngIf="unitLessons && selectedUnit != -1">
            <p class="fw-bold">Lección:</p>
            <select name="unit-lessons" id="unit-lessons" [(ngModel)]="selectedLesson" (ngModelChange)="selectLesson($event)">
                <option disabled selected value="-1">Seleccione una lección...</option>
                <option *ngFor="let lesson of unitLessons" value="{{ lesson.id }}">
                    {{ lesson.name }}
                </option>
            </select>
        </label>
        
        <label for="lesson-headings" class="d-block" *ngIf="destination == 'heading' && lessonHeadings.length > 0">
            <p class="fw-bold">Enunciado:</p>
            <select name="lesson-headings" id="lesson-headings" [(ngModel)]="selectedHeading">
                <option disabled selected value="-1">Seleccione un enunciado...</option>
                <option *ngFor="let heading of lessonHeadings" [value]="heading.id">
                    {{ heading.name }}
                </option>
            </select>
        </label>
    </div>

    <div id="save-images-status" class="mt-3">
        <div id="save-images-loading" *ngIf="imageSaving">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Guardando imágenes, espere por favor...</span>
        </div>
        <div id="save-images-success" class="text-success" *ngIf="imageSaveSuccess">
            <i class="fa fa-check"></i>
            <span>¡Imágenes guardadas exitosamente!</span>
        </div>
        <div id="save-images-error" class="text-danger" *ngIf="imageSaveError">
            <i class="fa fa-times"></i>
            <span>Las imágenes no se han podido guardar correctamente.</span>
        </div>
    </div>

    <div id="generate-images-save-buttons" class="mt-4" *ngIf="destination != ''">
        <button class="btn btn-primary me-3" routerLink="/course/{{ courseID }}" routerLinkActive="active">
            <i class="fa fa-arrow-left"></i>
            <span>Volver</span>
        </button>

        <button class="btn btn-success me-3" (click)="saveImages()">
            <i class="fa fa-images"></i>
            <span *ngIf="destination == 'lesson'">Asociar a lección</span>
            <span *ngIf="destination == 'heading'">Insertar en enunciado</span>
        </button>
    </div>
</div>